var map = {
	"./LateSerif-Black.woff": 4778,
	"./LateSerif-Bold.woff": 8962,
	"./LateSerif-Italic.woff": 3573,
	"./LateSerif-Medium.woff": 1035,
	"./LateSerif-Regular.woff": 9845,
	"./LateSerif.var.woff": 4858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3879;